<div class="flex flex-col flex-auto min-w-0">
    <div class="sm:absolute sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Permissions</div>

            <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            </div>
        </div>

        <div class="flex flex-auto overflow-hidden">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div>Role</div>
                        <div class="right-0">Détail</div>
                    </div>
                    <ng-container *ngFor="let role of roles; trackBy: trackByFn">
                        <div id="{{'role-' + role.id}}" class="table-grid grid items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div class="">{{role.role}}</div>
                            <div class="right-0">
                                <button class="min-w-10 min-h-7 h-7 px-2 leading-6" mat-stroked-button (click)="edit(role.id)">
                                    <mat-icon class="icon-size-5" [svgIcon]="currentRole?.id === role.id ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down'"></mat-icon>
                                </button>
                            </div>
                        </div>
                        <div class="grid">
                            <ng-container *ngIf="currentRole?.id === role.id">
                                <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: {$implicit: role}"></ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <ng-template #rowDetailsTemplate let-role>
                    <div class="shadow-lg overflow-hidden">
                        <div class="flex border-b">
                            <form class="flex flex-col w-full">
                                <div class="p-8 pt-4 pb-4">
                                    <div class="w-full">
                                        <ul class="columns-1 md:columns-2">
                                            <li *ngFor="let module of allModules" class="p-8 pt-4 pb-0 space-x-4">
                                                <mat-checkbox [checked]="checkIfAccess(module.id)" (change)="setModules(module.id, $event.checked)">{{module.nom}}</mat-checkbox>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="flex items-center justify-between w-full border-t px-8 py-4">
                                    <div class="flex items-center">
                                        <div class="flex items-center mr-4">
                                            <ng-container *ngIf="success">
                                                <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
                                                <span class="ml-2">Permissions mises à jour</span>
                                            </ng-container>
                                            <ng-container *ngIf="error">
                                                <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                                                <span class="ml-2">Erreur lors de l'enregistrement, réessayez!</span>
                                            </ng-container>
                                        </div>
                                        <button (click)="onFormSubmit()" type="button" mat-flat-button [color]="'primary'">
                                            Enregistrer
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </ng-template>
                
            </div>
        </div>
    </div>
</div>
